
import './vegas.js';

$(function() {

    $('.xahamar-portada').vegas({
    	timer: false,
        delay: 4500,
    	shuffle: false,
    	color: '#444',
    	firstTransition: 'fade2',
    	transition: 'fade2',
        slides: [
            { src: '/img/slider/1.jpg' },
            { src: '/img/slider/2.jpg' },
            { src: '/img/slider/3.jpg' },
            { src: '/img/slider/4.jpg' },
            { src: '/img/slider/5.jpg' },
            { src: '/img/slider/6.jpg' }
        ],
        animation: 'kenburns'
    });
    

});